import { connect } from 'formik';
import PropTypes from 'prop-types';
import React from 'react';

import { smoothScrollToOffset } from '../FormWrapper';

/**
 * Listens for validation errors in a form and scrolls to the first
 */
class ErrorFocus extends React.Component {
  componentDidUpdate(prevProps) {
    const { isSubmitting, isValidating, errors } = prevProps.formik;
    const keys = Object.keys(errors);
    if (keys.length > 0 && isSubmitting && !isValidating) {
      const selector = `[name="${keys[0]}"]`;
      const errorElement = document.querySelector(selector);
      if (errorElement) {
        smoothScrollToOffset(errorElement, this.props.offset);
      }
    }
  }

  render() {
    return null;
  }
}

ErrorFocus.defaultProps = {
  offset: 40,
};

ErrorFocus.propTypes = {
  formik: PropTypes.any,
  /** Amount in pixels to scroll to above the field */
  offset: PropTypes.number,
};

export default connect(ErrorFocus);
